import React, { useState, useEffect } from 'react';
import './VerifyOtpModal.css';

const VerifyOtpModal = ({ phoneNumber, onSubmit, onClose }) => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 6);
    setOtp(value);
    if (error) setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otp || otp.length < 4) {
      setError('Please enter a valid OTP code.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await onSubmit(otp);
    } catch (err) {
      setError(err.message || 'Failed to verify OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vci-otp-modal-overlay">
      <div className="vci-otp-modal-content">
        <button type="button" className="vci-otp-modal-close" onClick={onClose} disabled={loading}>
          ×
        </button>
        <div className="vci-otp-modal-header">
          <div className="vci-otp-modal-icon">
            <i className="la la-comment"></i>
          </div>
          <h3>Enter Verification Code</h3>
        </div>
        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
          <div className="vci-otp-modal-body">
            <p className="vci-otp-modal-desc">
              A verification code has been sent via SMS to:
            </p>
            <p className="vci-otp-modal-phone">
              <strong>{phoneNumber}</strong>
            </p>

            {error && (
              <div className="vci-otp-modal-error">
                {error}
              </div>
            )}

            <div className="vci-otp-input-group">
              <label>Verification Code</label>
              <input
                type="text"
                className="vci-otp-input"
                placeholder="Enter 6-digit code"
                value={otp}
                onChange={handleOtpChange}
                disabled={loading}
                autoFocus
                autoComplete="off"
              />
            </div>
          </div>
          <div className="vci-otp-modal-footer">
            <button
              type="button"
              className="btn linear-gradient-cancel"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn linear-gradient"
              disabled={loading || otp.length < 4}
            >
              {loading ? 'Verifying...' : 'Verify'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VerifyOtpModal;
